// src/app/core/registry/component-registry.ts

import { DashboardOverviewComponent } from '../../pages/private/dashboard/dashboard-overview/dashboard-overview.component';
import { OperationRecoveryComponent } from '../../pages/private/dashboard/operation-recovery/operation-recovery.component';
import { Type } from '@angular/core';
import { MonthlyReport1Component } from '../../pages/private/dashboard/monthly-report-1/monthly-report-1.component';
import { MonthlyReport2Component } from '../../pages/private/dashboard/monthly-report-2/monthly-report-2.component';
import { OverdueCronComponent } from '../../pages/private/overdue-cron/overdue-cron.component';
import { LendeeDashboardComponent } from '../../pages/private/dashboard/lendee-dashboard/lendee-dashboard.component';
import { CoolCreditDashboardComponent } from '../../pages/private/dashboard/cool-credit-dashboard/cool-credit-dashboard.component';
import { SocialPlatformComponent } from '../../pages/private/dashboard/social-platform/social-platform.component';
import { BusinessPerformanceReportComponent } from '../../pages/private/visionboard/business-performance-report/business-performance-report.component';
import { ContractsReportComponent } from '../../pages/private/visionboard/contracts-report/contracts-report.component';
import { PromptInfoComponent } from '../../pages/private/prompt-info/prompt-info.component';
import { MatrixWebappComponent } from '../../pages/private/matrix-webapp/matrix-webapp.component';
import { PromptFeaturesComponent } from '../../pages/private/prompt-info/features/features.component';
import { PromptOptionsComponent } from '../../pages/private/prompt-info/options/options.component';
import { PromptMappingsComponent } from '../../pages/private/prompt-info/mappings/mappings.component';
import { PromptManagerComponent } from '../../pages/private/prompt-info/prompt-manager/prompt-manager.component';
import { PageRoutesComponent } from '../../pages/private/menu-roles/page-routes/page-routes.component';
import { RoleMenuAccessComponent } from '../../pages/private/menu-roles/role-menu-access/role-menu-access.component';
import { ManageRolesComponent } from '../../pages/private/menu-roles/manage-roles/manage-roles.component';
import { CallHistoryComponent } from '../../pages/private/call-history/call-history.component';
import { SeoStatsComponent } from '../../pages/private/dashboard/seo-stats/seo-stats.component';
import { SeoOverviewComponent } from '../../pages/private/dashboard/seo-overview/seo-overview.component';
import { DailyCronComponent } from '../../pages/private/daily-cron/daily-cron.component';
import { ArrangmentCronComponent } from '../../pages/private/arrangment-cron/arrangment-cron.component';
import { OverviewNewComponent } from '../../pages/private/arrangment-cron/components/overview-new/overview-new.component';
import { TrendsComponent } from '../../pages/private/arrangment-cron/components/trends/trends.component';
import { AdminPerformanceComponent } from '../../pages/private/arrangment-cron/components/admin-performance/admin-performance.component';


import { IndustryWiseCategorizationComponent } from '../../pages/private/dashboard/industry-wise-categorization/industry-wise-categorization.component';
import { UserComponent } from '../../pages/private/user/user.component';
import { GrowthActivationAndRevenueComponent } from '../../pages/private/Cool Credit DashBoard/growth-activation-and-revenue/growth-activation-and-revenue.component';
import { CampaignAdsStatsComponent } from '../../pages/private/dashboard/campaign-ads-stats/campaign-ads-stats.component';
import { RolesComponent } from '../../pages/private/menu-roles/roles/roles.component';
import { LendeeAnalyticsDashboardComponent } from '../../pages/private/Lendee DashBoard/lendee-analytics-dashboard/lendee-analytics-dashboard.component';
import { ReleaseDocumentComponent } from '../../pages/private/release-document/release-document.component';
import { UserProfileComponent } from '../../pages/private/profile/profile.component';
import { KnowledgeBaseComponent } from '../../pages/private/knowledge-base/knowledge-base.component';
import { AiSummaryDetailComponent } from '../../pages/private/ai-summary-detail/ai-summary-detail.component';
import { AccessRequestLogsComponent } from '../../pages/private/user/access-request-logs/access-request-logs.component';
import { CallDetailsComponent } from '../../pages/private/call-history/call-details/call-details.component';
import { CallQualityComponent } from '../../pages/private/call-quality/call-quality.component';
import { TrainingDashboardComponent } from '../../pages/private/dashboard/training-dashboard/training-dashboard.component';
import { TrainingConversionComponent } from '../../pages/private/dashboard/training-conversion/training-conversion.component';
import { PipelinePortfolioComponent } from '../../pages/private/dashboard/pipeline-portfolio/pipeline-portfolio.component';
import { MyDashboardComponent } from '../../pages/private/dashboard/my-dashboard/my-dashboard.component';

import { PractinaDashboardComponent } from '../../pages/private/practina/dashboard/practina-dashboard.component';
import { ChatbotListComponent } from '../../pages/private/chatbot/chatbot-list/chatbot-list.component';
import { ChatbotCanvasComponent } from '../../pages/private/chatbot/chatbot-canvas/chatbot-canvas.component';
import { DefaultSettingsComponent } from '../../pages/private/chatbot/default-settings/default-settings.component';
import { KeyManagerComponent } from '../../pages/private/key-manager/key-manager.component';
import { CrmPanelComponent } from '../../pages/public/crm-panel/crm-panel.component';
import { UnpaidPaymentsV2ParentComponent } from '../../pages/private/unpaid-payments-v2/unpaid-payments-v2-parent.component';
import { UnpaidPaymentsOverviewStubComponent } from '../../pages/private/unpaid-payments-v2/unpaid-payments-overview-stub.component';
import { UnpaidPaymentsLendeeComponent } from '../../pages/private/unpaid-payments-v2/children/lendee/unpaid-payments-lendee.component';
import { UnpaidPaymentsDenefitsComponent } from '../../pages/private/unpaid-payments-v2/children/denefits/unpaid-payments-denefits.component';
import { UnpaidPaymentsCredeeComponent } from '../../pages/private/unpaid-payments-v2/children/credee/unpaid-payments-credee.component';
import { UnpaidPaymentsRecuveryComponent } from '../../pages/private/unpaid-payments-v2/children/recuvery/unpaid-payments-recuvery.component';
import { UnpaidPaymentsFmComponent } from '../../pages/private/unpaid-payments-v2/children/fm/unpaid-payments-fm.component';
import { AppRoutesComponent } from '../../pages/private/menu-roles/app-routes/app-routes.component';
import { DeckAdminComponent } from '../../pages/private/deck-admin/deck-admin.component';
import { TrackingDemoComponent } from '../../pages/private/tracking-demo/tracking-demo.component';
import { RecuveryDashboardComponent } from '../../pages/private/dashboard/recuvery-dashboard/recuvery-dashboard.component';
import { RecuveryPipelinePortfolioComponent } from '../../pages/private/dashboard/recuvery-pipeline-portfolio/recuvery-pipeline-portfolio.component';

// lazy loadin handling
export type LazyComponentLoader = () => Promise<Type<unknown>>;
export const LAZY_COMPONENT_LOADERS: Record<string, LazyComponentLoader> = {
  CrmPanelComponent: () =>
    import('../../pages/public/crm-panel/crm-panel.component').then(
      (m) => m.CrmPanelComponent,
    ),
  // Lazy on purpose: pulls livekit-client, which would otherwise land in the
  // eager bundle (the public LiveKit demo pages are lazy routes too).
  TrackingDemoV2Component: () =>
    import('../../pages/private/tracking-demo-v2/tracking-demo-v2.component').then(
      (m) => m.TrackingDemoV2Component,
    ),
  CallAuditorAuditsComponent: () =>
    import('../../pages/private/call-auditor/audits/audits.component').then(
      (m) => m.CallAuditorAuditsComponent,
    ),
  CallAuditorUploadComponent: () =>
    import('../../pages/private/call-auditor/upload/upload.component').then((m) => m.CallAuditorUploadComponent),
  CallAuditorProfilesComponent: () =>
    import('../../pages/private/call-auditor/profiles/profiles.component').then((m) => m.CallAuditorProfilesComponent),
  CallAuditorKnowledgeComponent: () =>
    import('../../pages/private/call-auditor/knowledge/knowledge.component').then((m) => m.CallAuditorKnowledgeComponent),
  CallAuditorCalibrationComponent: () =>
    import('../../pages/private/call-auditor/calibration/calibration.component').then(
      (m) => m.CallAuditorCalibrationComponent,
    ),
  LeadFinderFindComponent: () =>
    import('../../pages/private/lead-finder/find/find-leads.component').then((m) => m.LeadFinderFindComponent),
  LeadFinderLeadsComponent: () =>
    import('../../pages/private/lead-finder/leads/leads.component').then((m) => m.LeadFinderLeadsComponent),
  LeadFinderChatsComponent: () =>
    import('../../pages/private/lead-finder/find/find-leads.component').then((m) => m.LeadFinderChatsComponent),
  LeadFinderCostingComponent: () =>
    import('../../pages/private/lead-finder/costing/costing.component').then((m) => m.LeadFinderCostingComponent),
  LeadFinderAgentsComponent: () =>
    import('../../pages/private/lead-finder/agents/agents.component').then((m) => m.LeadFinderAgentsComponent),
  LeadFinderMyLeadsComponent: () =>
    import('../../pages/private/lead-finder/my-leads/my-leads.component').then((m) => m.LeadFinderMyLeadsComponent),
  ApiKeysComponent: () =>
    import('../../pages/private/api-keys/api-keys.component').then((m) => m.ApiKeysComponent),
  AccessComponent: () =>
    import('../../pages/private/access/access-shell.component').then((m) => m.AccessShellComponent),
  AccessUsersComponent: () =>
    import('../../pages/private/access/users/access-users.component').then((m) => m.AccessUsersComponent),
  AccessRolesComponent: () =>
    import('../../pages/private/access/roles/access-roles.component').then((m) => m.AccessRolesComponent),
  AccessUserDetailComponent: () =>
    import('../../pages/private/access/users/access-user-detail.component').then((m) => m.AccessUserDetailComponent),
  AccessRoleDetailComponent: () =>
    import('../../pages/private/access/roles/access-role-detail.component').then((m) => m.AccessRoleDetailComponent),
  AccessRequestsComponent: () =>
    import('../../pages/private/access/requests/access-requests.component').then((m) => m.AccessRequestsComponent),
  ProductDashboardFrameComponent: () =>
    import('../../pages/private/product-dashboard-frame/product-dashboard-frame.component').then(
      (m) => m.ProductDashboardFrameComponent),
  // Lazy: its recording player pulls rrweb.
  AiAssistantTrackingComponent: () =>
    import('../../pages/private/ai-assistant-tracking/ai-assistant-tracking.component').then(
      (m) => m.AiAssistantTrackingComponent,
    ),
};

/** True when `componentName` resolves to a page — eager or lazy. */
export function isRegisteredComponent(componentName: string | null | undefined): boolean {
  return !!componentName
    && (componentName in COMPONENT_REGISTRY || componentName in LAZY_COMPONENT_LOADERS);
}
export const COMPONENT_REGISTRY: Record<string, any> = {
  DashboardOverviewComponent,
  MonthlyReport1Component,
  MonthlyReport2Component,
  OverdueCronComponent,
  LendeeDashboardComponent,
  CoolCreditDashboardComponent,
  SocialPlatformComponent,
  BusinessPerformanceReportComponent,
  ContractsReportComponent,
  PromptInfoComponent,
  MatrixWebappComponent,
  PromptFeaturesComponent,
  PromptOptionsComponent,
  PromptMappingsComponent,
  PromptManagerComponent,
  PageRoutesComponent,
  ManageRolesComponent,
  RoleMenuAccessComponent,
  CallHistoryComponent,
  CallDetailsComponent,
  SeoStatsComponent,
  SeoOverviewComponent,
  IndustryWiseCategorizationComponent,
  UserComponent,
  DailyCronComponent,
  GrowthActivationAndRevenueComponent,
  CampaignAdsStatsComponent,
  ArrangmentCronComponent,
  OverviewNewComponent,
  TrendsComponent,
  AdminPerformanceComponent,
  RolesComponent,
  LendeeAnalyticsDashboardComponent,
  ReleaseDocumentComponent,
  UserProfileComponent,
  KnowledgeBaseComponent,
  AiSummaryDetailComponent,
  AccessRequestLogsComponent,
  PractinaDashboardComponent,
  CallQualityComponent,
  ChatbotListComponent,
  ChatbotCanvasComponent,
  DefaultSettingsComponent,
  KeyManagerComponent,
  TrainingDashboardComponent,
  CrmPanelComponent,
  UnpaidPaymentsV2ParentComponent,
  UnpaidPaymentsOverviewStubComponent,
  UnpaidPaymentsLendeeComponent,
  UnpaidPaymentsDenefitsComponent,
  UnpaidPaymentsCredeeComponent,
  UnpaidPaymentsRecuveryComponent,
  UnpaidPaymentsFmComponent,
  AppRoutesComponent,
  TrainingConversionComponent,
  PipelinePortfolioComponent,
  MyDashboardComponent,
  DeckAdminComponent,
  TrackingDemoComponent,
  OperationRecoveryComponent,
  RecuveryDashboardComponent,
  RecuveryPipelinePortfolioComponent
};
